import { Tooltip } from "antd";
import React from "react";
import styled from "styled-components";
import { prettyCount } from "../../../utils/format";
import MiniTable from "../common/mini-table";

const NameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const CountBar = styled.div<{ $width: string; $color: string; $opacity: number }>`
  height: 6px;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
  width: ${props => props.$width};
  background-color: ${props => props.$color};
  opacity: ${props => props.$opacity};
`;

const GetTableColumns = (column_name: string, color: string, ref_value: number) => {
  return [
    {
      title: column_name,
      dataIndex: 'name',
      key: 'name',
      className: 'capitalize-text',
      render: (text: any, record: any, index: number) => (
        <NameCell>
          <CircleDot $color={color} $opacity={1 - 0.2 * index} />
          <Tooltip placement="topLeft" title={isNaN(parseInt(record.name)) ? unescape(record.name) : `${record.name} Years`} arrowPointAtCenter>
            {`${isNaN(parseInt(record.name)) ? unescape(record.name) : `${record.name} Years`}`}
          </Tooltip>
        </NameCell>
      )
    },
    {
      title: 'Matches',
      dataIndex: 'prfs',
      key: 'prfs',
      align: 'right',
      render: (text: any, record: any) => (
        <>{`${prettyCount(record.prfs.length)}`}</>
      )
    },
    {
      title: '',
      dataIndex: 'prfs',
      key: 'prfs',
      align: 'right',
      render: (prfs: any, record: any, index: number) => (
        <CountBar
          $width={prfs.length > 0 ? `${112 * (prfs.length/ref_value)}px` : '2px'}
          $color={color}
          $opacity={1 - 0.2*index}
        />
      )
    }
  ];
}

const TableWrapper = styled.div`
  margin: 10px;
  background-color: #F7F8FA;
  width: 403px;
  padding: 20px 0px;
  border-radius: 10px;
  display: inline-block;
`;

const CircleDot = styled.span<{ $color: string; $opacity: number }>`
  min-height: 8px;
  min-width: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
  background-color: ${props => props.$color};
  opacity: ${props => props.$opacity};
`;

const InsightsContainer = styled.div`
  margin: 20px 0px;
`;

type SearchInsightsProps = {
  analyzeMatchesData: any
}

const SearchInsights = (props: SearchInsightsProps) => {
  const { analyzeMatchesData } = props;

  return (
    <InsightsContainer>
      {analyzeMatchesData.top_curr_comps && (
        <>
          <TableWrapper>
            <MiniTable
              title="Top Employers"
              columns={GetTableColumns('COMPANIES', '#308DF8', analyzeMatchesData.top_curr_comps[0]?.prfs.length || 0)}
              data={analyzeMatchesData.top_curr_comps.slice(0, 5)}
            />
          </TableWrapper>
          <TableWrapper>
            <MiniTable
              title="Top Skills"
              columns={GetTableColumns('SKILLS', '#285384', analyzeMatchesData.top_skills[0]?.prfs.length || 0)}
              data={analyzeMatchesData.top_skills.slice(0, 5)}
            />
          </TableWrapper>
          <TableWrapper>
            <MiniTable
              title="Top Schools"
              columns={GetTableColumns('SCHOOLS', '#6BCA85', analyzeMatchesData.top_schools[0]?.prfs.length || 0)}
              data={analyzeMatchesData.top_schools.slice(0, 5)}
            />
          </TableWrapper>
          <TableWrapper>
            <MiniTable
              title="Top Employers by Funding Stage"
              columns={GetTableColumns('Funding Stage', '#D4B1FF', analyzeMatchesData.top_funding[0]?.prfs.length || 0)}
              data={analyzeMatchesData.top_funding.slice(0, 5)}
            />
          </TableWrapper>
        </>
      )}
    </InsightsContainer>
  );
}

export default SearchInsights;